var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: _vm.$style.container
  }, [_c('MileCountdown', {
    attrs: {
      "height": 400
    }
  })], 1), _c('div', {
    class: _vm.$style.container2
  }, [_c('MileCountdown', {
    attrs: {
      "height": 200
    }
  })], 1), _c('div', {
    class: _vm.$style.container3
  }, [_c('MileCountdown', {
    attrs: {
      "height": 104
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }